var _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "247px",
    height: "247px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 32.5,
    width: 15,
    height: 35,
    fill: "#5e3ea1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "0.8928571428571428s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "20.249999999999996;32.5;32.5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.17857142857142858s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "0.8928571428571428s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "59.50000000000001;35;35",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.17857142857142858s"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 32.5,
    width: 15,
    height: 35,
    fill: "#8789b9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "0.8928571428571428s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "23.312499999999996;32.5;32.5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.08928571428571429s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "0.8928571428571428s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "53.37500000000001;35;35",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.08928571428571429s"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 32.5,
    width: 15,
    height: 35,
    fill: "#d83964"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "0.8928571428571428s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "23.312499999999996;32.5;32.5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "0.8928571428571428s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "53.37500000000001;35;35",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.b3be24e5e7bfdbce0d792c086991bc26.svg";
export { ForwardRef as ReactComponent };